import React from "react"
import { CheckCircle2 } from "lucide-react"
import type { GeneratorStep } from "../types"
import "./GeneratorStepper.style.scss"

interface GeneratorStepperProps {
  step: GeneratorStep
}

const StepIndicator = ({
  num,
  label,
  active,
  current,
}: {
  num: number
  label: string
  active: boolean
  current: boolean
}) => (
  <div className="generator-stepper__item">
    <div
      className={`generator-stepper__dot${active ? " is-active" : ""}${
        current ? " is-current" : ""
      }`}
    >
      {active && !current ? <CheckCircle2 size={16} /> : num}
    </div>
    <span
      className={`generator-stepper__label${current ? " is-current" : ""}${
        active && !current ? " is-done" : ""
      }`}
    >
      {label}
    </span>
  </div>
)

const GeneratorStepper = ({ step }: GeneratorStepperProps) => {
  const width = step === 1 ? "0%" : step === 2 ? "50%" : "100%"
  return (
    <div className="generator-stepper">
      <div className="generator-stepper__track">
        <div className="generator-stepper__fill" style={{ width }} />
      </div>
      <StepIndicator num={1} label="Subject" active={step >= 1} current={step === 1} />
      <StepIndicator
        num={2}
        label="Configure"
        active={step >= 2}
        current={step === 2}
      />
      <StepIndicator num={3} label="Ready" active={step >= 3} current={step === 3} />
    </div>
  )
}

export default GeneratorStepper
